import { render, staticRenderFns } from "./UpdateCheckBoardColorDialog.vue?vue&type=template&id=6b23252e&scoped=true"
import script from "./UpdateCheckBoardColorDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCheckBoardColorDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateCheckBoardColorDialog.vue?vue&type=style&index=0&id=6b23252e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b23252e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b23252e')) {
      api.createRecord('6b23252e', component.options)
    } else {
      api.reload('6b23252e', component.options)
    }
    module.hot.accept("./UpdateCheckBoardColorDialog.vue?vue&type=template&id=6b23252e&scoped=true", function () {
      api.rerender('6b23252e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/UpdateCheckBoardColorDialog.vue"
export default component.exports